import React from "react";
import "./PathOption.css";

function PathOption({ 
  id, 
  label, 
  checked, 
  onChange, 
  disabled = false,
  children // Nested checkboxes
}) {
  return (
    <div className={`path-option-wrapper ${disabled ? 'disabled' : ''}`}>
      <label className={`path-option ${disabled ? 'disabled' : ''}`}>
        <input
          type="checkbox"
          id={id}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className="path-option-checkbox"
        />
        <span className="path-option-label">{label}</span>
      </label>
      {children && (
        <div className="path-option-children">
          {children}
        </div>
      )}
    </div>
  );
}

export default PathOption;

